export function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
}
export function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}
export function isString(val) {
  return Object.prototype.toString.call(val) === '[object String]';
}
export const isSSR = function () {
  try {
    return !(typeof window !== 'undefined' && document !== undefined);
  } catch (e) {
    return true;
  }
}();
export function isEmpty(obj) {
  if (typeof obj === 'undefined' || obj === null || obj === '' || obj === '0' || obj === false || obj === 0 || Array.isArray(obj) && obj.length === 0 || typeof obj === 'object' && Object.keys(obj).length === 0) {
    return true;
  } else {
    return false;
  }
}
export function toNumber(value) {
  value = value.replace(/,/g, '');
  return isEmpty(value) ? 0 : value;
}